import { ModalCustom } from '$src/components/Modal';
import { CustomIcon } from '$src/components/CustomIcon';
import { LINKED_ACCOUNTS_URL } from '$src/constants/urls';
import PropTypes from 'prop-types';

import './index.less';

function Line({ text }) {
  return (
    <div className="authorize-vsg__line">
      <CustomIcon type="regular" name="check.svg" className="authorize-vsg__line-icon" />
      <p className="authorize-vsg__line-text">{text}</p>
    </div>
  );
}

Line.propTypes = {
  text: PropTypes.string.isRequired,
};

export default function AuthorizeDialog({ showModal, handleAuthorize, handleDeny, ...rest }) {
  return (
    <ModalCustom
      {...rest}
      title="Authorize Virtual Security Guard"
      data-testid="authorize-vsg"
      contentTitle={
        <div className="authorize-vsg__container">
          <h1>Authorize Virtual Security Guard </h1>
          <p>For the service to function, Rapid Response Monitoring Services Inc. needs permission to:</p>
        </div>
      }
      width="650px"
      contentMessage={
        <div className="authorize-vsg__container">
          <Line text="Access the devices you choose to enroll in Virtual Security Guard" />
          <Line text="Initiate Two-Way Talk and Siren via your device’s microphone and speaker" />
          <Line text="Access your Ring account details and emergency contacts for alerts" />
          <Line text="Send you text messages for monitored events at your location that require attention" />
          <p className="authorize-vsg__subtext">
            You can revoke this authorization at anytime, but the service will not function without it. If you want to revoke this permission, you can
            visit{' '}
            <a target="_blank" rel="noreferrer" href={LINKED_ACCOUNTS_URL}>
              {LINKED_ACCOUNTS_URL}
            </a>
          </p>
        </div>
      }
      visible={showModal}
      handleCancel={handleDeny}
      handleOk={handleAuthorize}
      okText="Authorize"
      cancelText="Deny"
    />
  );
}

AuthorizeDialog.propTypes = {
  showModal: PropTypes.bool.isRequired,
  handleAuthorize: PropTypes.func,
  handleDeny: PropTypes.func,
};
